export default {

    styleTablet : {
        display:'flex',
        background:'lightgray',
        borderRadius: '7px',
        alignItems: 'center',
        margin: '2px 1px'
    },
    crossbtn: {background:'gray',color:'#fff',borderTopRightRadius: '5px',
    borderBottomRightRadius: '5px', padding:'8px 3px', cursor:'pointer'},
    tabContainer : {display:'flex', flexFlow:'wrap', padding: '1.5px' },
    mainContiner : {display:'flex', border: '.5px solid #d9d9d9', borderRadius:'2px'},
    styInput: { width:'auto', alignSelf:'flex-end'}

}